module.exports = {
  footer: {
    html: `
    <div class="kk-block">
      <div class="kk-block-container kk-block-footer">
        <p class="kk-muted kk-mb-2">{{{footer}}}</p>
      </div>
    </div>`
  },
  hero: {
    html: `
    <div id="kk-hero" class="kk-block-hero {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">

      <div class="kk-nav" id="kk-nav">
        <div class="kk-container">
        <div class="kk-block-left kk-float-left">
          <a class="kk-link" href="/{{#if site_home}}{{site_home}}{{/if}}">
            {{#if logo_image}}
            <picture loading="lazy" class="kk-logo-image lazyload" alt="{{site_name}} logo">
              <source srcset="{{logo_image}}.webp" type="image/webp">
              <img loading="lazy" class="kk-logo-image lazyload" data-src="{{logo_image}}" alt="{{site_name}} logo"/>
            </picture>
            {{else}}
              <h3 class="kk-text-logo">{{site_name}}</h3>
            {{/if}}
          </a>
        </div>
        <div class="kk-block-right kk-nav-links" kk-float-right>
          <div class="pure-menu pure-menu-horizontal">
            <ul class="pure-menu-list">
            {{#each links}}
              {{#if sub_links}}
                <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover">
                    <a href="#" class="pure-menu-link">{{name}}</a>
                    <ul class="pure-menu-children">
                      {{#each sub_links}}
                        <li class="pure-menu-item">
                          <a href="/{{slug}}" class="pure-menu-link pure-sub-menu-link">{{name}}</a>
                        </li>
                      {{/each}}
                    </ul>
                </li>
              {{else}}
              <li class="pure-menu-item">
                <a href="/{{slug}}" class="pure-menu-link">{{name}}</a>
              </li>
              {{/if}}
            {{/each}}
            </ul>
          </div>
        </div>
      </div>
      </div>

      <div class="kk-block">
      {{#if image_side}}
        <div class="kk-container">
          <div class="kk-block-left">
            <h1>{{header}}</h1>
            <p class="kk-subheading kk-hero-subheading">{{sub_heading}}</p>
            {{#if action}}<a class="pure-button pure-button-primary" href="{{link}}">{{action}}</a>{{/if}}
          </div>
          <div class="kk-block-right">
          {{#if image}}
            <picture loading="lazy" class="kk-block-hero-image lazyload">
              <source srcset="{{image}}.webp" type="image/webp">
              <img loading="lazy" class="kk-block-hero-image lazyload" data-src="{{image}}">
            </picture>
          {{/if}}
          </div>
        </div>
      {{else}}
        <div class="kk-block-container">
          <h1>{{header}}</h1>
          <p class="kk-subheading kk-hero-subheading">{{sub_heading}}</p>
          {{#if action}}<a class="pure-button pure-button-primary" href="{{link}}">{{action}}</a>{{/if}}
          {{#if image}}
            <picture loading="lazy" class="kk-block-hero-image lazyload kk-mt-2">
              <source srcset="{{image}}.webp" type="image/webp">
              <img loading="lazy" class="kk-block-hero-image lazyload kk-mt-2" data-src="{{image}}">
            </picture>
          {{/if}}
        </div>
      {{/if}}
      </div>
    </div>`
  },
  faqs: {
    html: `
    <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
        <h2>{{header}}</h2>
        <p class="kk-subheading kk-mb-1">{{sub_heading}}</p>
        <button class="pure-button pure-button-primary">Ask a question</button>

        <div class="kk-mt-2">
          {{#each faqs}}
            <button class="accordion kk-mb-1" onclick="toggle_accordion(this)">{{question}}</button>
            <div class="panel">
              <h4>{{question}}</h4>
              <p>{{answer}}</p>
            </div>
          {{/each}}
          </div>
        </div>
      </div>`
  },
  awards: {
    // html: '<div class="kk-block"><div class="kk-block-container"><h2>{{header}}</h2><ul>{{#each awards}}<li>{{image}} - {{link}}</li>{{/each}}</ul></div></div>'
    html: `
    <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
        {{#if header}}
          <h2>{{header}}</h2>
        {{/if}}
        <p class="kk-subheading">{{sub_heading}}</p>
        <div class="kk-container">
          {{#each awards}}
            <a href="{{link}}">
              <picture loading="lazy" class="kk-logo lazyload" alt="{{entry.name}} logo">
                <source srcset="{{image}}.webp" type="image/webp">
                <source srcset="{{image}}" type="image/png">
                <img loading="lazy" class="kk-logo lazyload" data-src="{{image}}" alt="{{entry.name}} logo">
              </picture>
            </a>
          {{/each}}
        </div>
      </div>
    </div>`

  },
  form: {
    html: `
    <div class="kk-block  {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
      {{#if form}}
        <h2>{{form.header}}</h2>
        <p class="kk-subheading">{{form.sub_heading}}</p>

        <div class="kk-container">

          <form action="" method="post" id="form_{{form.header}}" onsubmit="event.preventDefault(); submit_form('form_{{form.header}}')" class="pure-form">
            <input type="hidden" value="{{form.header}}" name="form_id"/>

            {{#inArray form.fields "first_name"}}
              <input class="kk-form-input" placeholder="First name" name="first_name" required></input>
            {{/inArray}}

            {{#inArray form.fields "last_name"}}
              <input class="kk-form-input" placeholder="Last name" name="last_name" required></input>
            {{/inArray}}

            {{#inArray form.fields "email"}}
              <input class="kk-form-input" placeholder="Email" type="email" name="email" required></input>
            {{/inArray}}

            {{#inArray form.fields "phone"}}
              <input class="kk-form-input" placeholder="Phone" type="tel" name="phone" required></input>
            {{/inArray}}

            {{#inArray form.fields "comments"}}
              <textarea class="kk-form-input" placeholder="Enter your comments..." required rows="3" name="comments"></textarea>
            {{/inArray}}

            <button type="submit" class="pure-button pure-button-primary">Submit</button>
          </form>

        </div>
      {{else}}
        No form selected.
      {{/if}}

      </div>
    </div>`
  },
  testimonials: {
    html: `
    <div class="kk-block  {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
        <h2>{{header}}</h2>
        <p class="kk-subheading">{{sub_heading}}</p>

        <div class="pure-g gutters">

          {{#each testimonials}}
            <div class="pure-u-1-2 kk-mb-2">
              <div class="kk-card kk-space-between kk-float-left">
                <p>{{testimonial}}</p>
                <div class="pure-g gutters kk-bottom">
                {{#if person_image}}
                  <div class="pure-u-6-24">
                    <picture loading="lazy" class="kk-card-icon lazyload" alt="Face of {{person}}">
                      <source srcset="{{person_image}}.webp" type="image/webp">
                      <img loading="lazy" class="kk-card-icon lazyload" alt="Face of {{person}}" data-src="{{person_image}}"/>
                    </picture>
                  </div>
                  {{/if}}
                  <div class="pure-u-10-24 pure-v-center">
                    <span><strong>{{person}}</strong><br>
                    {{organisation}}</span>
                  </div>

                  {{#if person_image}}
                  {{else}}
                    <div class="pure-u-6-24">
                      <div class="kk-card-icon" style="width: 1px;"></div>
                    </div>
                  {{/if}}

                  <div class="pure-u-8-24 pure-v-center kk-float-right">
                    {{#eq rating 0}}<span>★★★★★</span>{{/eq}}
                    {{#eq rating 1}}<span><span class="pure-text-primary">★</span>★★★★</span>{{/eq}}
                    {{#eq rating 2}}<span><span class="pure-text-primary">★★</span>★★★</span>{{/eq}}
                    {{#eq rating 3}}<span><span class="pure-text-primary">★★★</span>★★</span>{{/eq}}
                    {{#eq rating 4}}<span><span class="pure-text-primary">★★★★</span>★</span>{{/eq}}
                    {{#eq rating 5}}<span><span class="pure-text-primary">★★★★★</span></span>{{/eq}}
                  </div>
                </div>
              </div>
            </div>
          {{/each}}

        </div>

      </div>
    </div>
    `
  },
  services: {
    html: `
    <div class="kk-block  {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
      <h2>{{header}}</h2>
      <p class="kk-subheading">{{sub_heading}}</p>
      <button class="pure-button pure-button-primary kk-mb-2">Our Services</button>

      <div class="pure-g gutters">
        {{#each services}}
          <div class="pure-u-1-2 kk-mb-2">
            <div class="kk-card pure-g">
              <div class="pure-u-6-24">
                <picture loading="lazy" class="kk-card-icon lazyload" alt="{{name}} icon">
                  <source srcset="{{icon}}.webp" type="image/webp">
                  <img loading="lazy" class="kk-card-icon lazyload" alt="{{name}} icon" data-src="{{icon}}"/>
                </picture>
              </div>
              <div class="pure-u-18-24 kk-float-left">
                <h3>{{name}}</h3>
                <p>{{description}}</p>
                <a class="pure-button pure-button-primary" href="/{{slug}}">{{name}}</a>
              </div>
            </div>
          </div>
        {{/each}}
      </div>
    </div>
  </div>`
  },
  article: {
    html: `
      <div class="kk-block kk-block-blog-container" {{#if background_image}}style="background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover;"{{/if}}>
        <div class="kk-block-container kk-block-blog">
          {{{text}}}
        </div>
      </div>`
  },
  features: {
    html: `
      <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      {{#if image_side}}
        <div class="kk-container">
          <div class="kk-block-left">
      {{else}}
        <div class="kk-block-container">
      {{/if}}
        <h2>{{header}}</h2>
        <p class="kk-subheading kk-mb-2">{{sub_heading}}</p>
        <div class="pure-g gutters">
          {{#each features}}
            <div class="pure-u-8-24 kk-mb-2">
              <div class="kk-card kk-text-center">
              <picture loading="lazy" class="kk-card-icon kk-m-a kk-mt-0 kk-mb-1 lazyload">
                <img loading="lazy" class="kk-card-icon kk-m-a kk-mt-0 kk-mb-1 lazyload" data-src="{{icon}}" alt="{{header}} icon"/>
              </picture>
               <h3>{{header}}</h3>
               <p>{{description}}</p>
              </div>
            </div>
          {{/each}}
        </div>
        {{#if image_side}}
          </div>
          <div class="kk-block-right">
            {{#if image}}
              <picture loading="lazy" class="kk-block-hero-image lazyload">
                <source srcset="{{image}}.webp" type="image/webp">
                <img loading="lazy" class="kk-block-hero-image lazyload" data-src="{{image}}">
              </picture>
              {{/if}}
          </div>
          </div>
        {{else}}
          {{#if image}}
            <picture loading="lazy" class="kk-block-image lazyload">
              <source srcset="{{image}}.webp" type="image/webp">
              <img loading="lazy" class="kk-block-image lazyload" data-src="{{image}}">
            </picture>
          {{/if}}
          </div>
        {{/if}}
      </div>`
  },
  checklist: {
    html: `
      <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
        <div class="kk-block-container">
          <h2>{{header}}</h2>
          <p class="kk-subheading">{{sub_heading}}</p>
          <ul class="kk-checklist">
            {{#each checklist}}
              <li>{{item}}</li>
            {{/each}}
          </ul>
        </div>
      </div>`
  },
  cta: {
    html: `
    <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
    {{#if image_side}}
      <div class="kk-container">
        <div class="kk-block-left">
        <h2>{{header}}</h2>
        <p class="kk-subheading">{{sub_heading}}</p>
        <a class="pure-button pure-button-primary" href="{{link}}">{{action}}</a>
        </div>
        <div class="kk-block-right">
        {{#if image}}
          <picture loading="lazy" class="kk-block-hero-image lazyload">
            <source srcset="{{image}}.webp" type="image/webp">
            <img loading="lazy" class="kk-block-hero-image lazyload" data-src="{{image}}">
          </picture>
        {{/if}}
        </div>
      </div>
    {{else}}
      <div class="kk-block-container">
      <h2>{{header}}</h2>
      <p class="kk-subheading">{{sub_heading}}</p>
      <a class="pure-button pure-button-primary" href="{{link}}">{{action}}</a>
        {{#if image}}
          <picture loading="lazy" class="kk-block-hero-image lazyload kk-mt-2">
            <source srcset="{{image}}.webp" type="image/webp">
            <img loading="lazy" class="kk-block-hero-image lazyload kk-mt-2" data-src="{{image}}">
          </picture>
        {{/if}}
      </div>
    {{/if}}
    </div>`
  },
  text: {
    html: `
    <div class="kk-block {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
    {{#if image_side}}
      <div class="kk-container">
        <div class="kk-block-left">
          <h2>{{header}}</h2>
          <p class="kk-subheading">{{sub_heading}}</p>
          <p class="kk-subheading">{{text}}</p>
        </div>
        <div class="kk-block-right">
        {{#if image}}
          <picture loading="lazy" class="kk-block-hero-image lazyload">
            <source srcset="{{image}}.webp" type="image/webp">
            <img loading="lazy" class="kk-block-hero-image lazyload" data-src="{{image}}">
          </picture>
        {{/if}}
        </div>
      </div>
    {{else}}
      <div class="kk-block-container">
        <h2>{{header}}</h2>
        <p class="kk-subheading">{{sub_heading}}</p>
        <p class="kk-subheading">{{text}}</p>
        {{#if image}}
          <picture loading="lazy" class="kk-block-hero-image lazyload kk-mt-2">
            <source srcset="{{image}}.webp" type="image/webp">
            <img loading="lazy" class="kk-block-hero-image lazyload kk-mt-2" data-src="{{image}}">
          </picture>
        {{/if}}
      </div>
    {{/if}}
    </div>`
  },
  blogs: {
    html: `
    <div class="kk-block  {{#eq text_color 'light'}}text-light{{/eq}}{{#eq text_color 'dark'}}text-dark{{/eq}}" style="{{#if background_image}}background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('{{background_image}}'); background-position: center center; background-size: cover; {{/if}} {{#if background_colour}}background-color: {{background_colour}} !important{{/if}}">
      <div class="kk-block-container">
        <h2>{{header}}</h2>
        <p class="kk-subheading kk-mb-2">{{sub_heading}}</p>
        <div class="pure-g gutters">
          {{#each blogs}}
            <div class="pure-u-8-24 kk-mb-2">
              <div class="kk-card">
               <h3>{{title}}</h3>
               <p>{{description}}</p>
               <a class="pure-button pure-button-primary" href="/{{slug}}">Read</a>
              </div>
            </div>
          {{/each}}
        </div>
      </div>
    </div>`
  }
}
